import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
const PHASES = [
    { label: "Understanding role requirements", from: 0, to: 25, duration: 1200 },
    { label: "Analyzing candidate profile", from: 25, to: 55, duration: 1600 },
    { label: "Generating interview objectives", from: 55, to: 85, duration: 2200 },
    { label: "Finalizing structure", from: 85, to: 92, duration: 1400 },
];
const FINAL_THOUGHTS = [
    "Balancing question difficulty",
    "Ensuring role relevance",
    "Removing biased phrasing",
    "Structuring evaluation criteria",
    "Applying interview best practices",
];
export const ObjectiveProgressLoader = ({ compact = false } = {}) => {
    var _a, _b;
    const [progress, setProgress] = useState(0);
    const [phaseIndex, setPhaseIndex] = useState(0);
    const [thoughtIndex, setThoughtIndex] = useState(0);
    const isFinalPhase = progress >= 92;
    useEffect(() => {
        const phase = PHASES[phaseIndex];
        if (!phase)
            return;
        const start = Date.now();
        const range = phase.to - phase.from;
        const animate = () => {
            const elapsed = Date.now() - start;
            const pct = Math.min(elapsed / phase.duration, 1);
            setProgress(Math.round(phase.from + range * pct));
            if (pct < 1) {
                requestAnimationFrame(animate);
            }
            else {
                setPhaseIndex((i) => i + 1);
            }
        };
        animate();
    }, [phaseIndex]);
    useEffect(() => {
        if (!isFinalPhase)
            return;
        const interval = setInterval(() => {
            setThoughtIndex((i) => (i + 1) % FINAL_THOUGHTS.length);
        }, 700);
        return () => clearInterval(interval);
    }, [isFinalPhase]);
    if (compact) {
        return (_jsxs("div", { className: "flex w-[220px] flex-col gap-1", children: [_jsx("div", { className: "h-1.5 w-full overflow-hidden rounded-full bg-dash-active", children: _jsx("div", { className: "h-full rounded-full bg-gradient-to-r from-dash-accent to-dash-purple transition-all duration-300", style: { width: `${progress}%` } }) }), _jsx("p", { className: "truncate text-xs text-dash-muted", children: isFinalPhase ? 'Performing final quality checks' : (_a = PHASES[phaseIndex]) === null || _a === void 0 ? void 0 : _a.label })] }));
    }
    return (_jsxs("div", { className: "flex w-[320px] flex-col items-center space-y-4", children: [_jsx("div", { className: "h-2 w-full overflow-hidden rounded-full bg-dash-active", children: _jsx("div", { className: "h-full rounded-full bg-gradient-to-r from-dash-accent to-dash-purple transition-all duration-300", style: { width: `${progress}%` } }) }), !isFinalPhase ? (_jsxs(_Fragment, { children: [_jsx("p", { className: "text-center text-sm text-dash-text2", children: (_b = PHASES[phaseIndex]) === null || _b === void 0 ? void 0 : _b.label }), _jsxs("span", { className: "text-xs font-medium text-dash-muted", children: [progress, "%"] })] })) : (_jsxs(_Fragment, { children: [_jsx("p", { className: "text-sm font-medium text-dash-text", children: "Performing final quality checks" }), _jsxs("div", { className: "flex items-center gap-2 text-xs text-dash-muted", children: [_jsx("span", { className: "animate-pulse text-dash-accentInk", children: "\u2022" }), _jsx("span", { children: FINAL_THOUGHTS[thoughtIndex] })] })] }))] }));
};
